import _extends from "@babel/runtime/helpers/esm/extends";
import React, { Component } from 'react';
import { Formik, Form, Field, ErrorMessage, withFormik } from 'formik';
import * as yup from 'yup';
import { Row, Col } from 'react-bootstrap';
import { Link } from '@sitecore-jss/sitecore-jss-react';
import Heading from '../../heading/Heading';
import states from '../util/usaStates';
import { FormCheckbox, FormInput, FormSelect } from '../elements';
import { useHistory } from 'react-router-dom'; // Global Element

export default (function (props) {
  var changeHandler = props.changeHandler,
      setFieldValue = props.setFieldValue,
      firstName = props.firstName,
      lastName = props.lastName,
      phoneNumber = props.phoneNumber,
      emailAddress = props.emailAddress,
      userZipCode = props.userZipCode,
      streetAddress = props.streetAddress,
      city = props.city,
      state = props.state,
      newsletter = props.newsletter,
      _props$terms = props.terms,
      terms = _props$terms === void 0 ? {} : _props$terms,
      _props$privacy = props.privacy,
      privacy = _props$privacy === void 0 ? {} : _props$privacy,
      values = props.values;
  var history = useHistory();

  var handleUrl = function handleUrl(url) {
    history.push(url);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Heading, {
    level: "2",
    field: {
      value: "Tell us about yourself."
    },
    className: "cb-type__title"
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: "6"
  }, /*#__PURE__*/React.createElement(Field, {
    value: values.firstName,
    name: "firstName",
    label: "First Name",
    component: FormInput,
    className: "cb-form__input--full",
    changeFullHandler: changeHandler
  })), /*#__PURE__*/React.createElement(Col, {
    sm: "6"
  }, /*#__PURE__*/React.createElement(Field, {
    value: values.lastName,
    name: "lastName",
    label: "Last Name",
    component: FormInput,
    className: "cb-form__input--full",
    changeFullHandler: changeHandler
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Field, {
    value: values.phoneNumber,
    type: "tel",
    name: "phoneNumber",
    label: "Phone Number",
    component: FormInput,
    className: "cb-form__input--full",
    changeFullHandler: changeHandler
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Field, {
    value: values.emailAddress,
    type: "email",
    name: "emailAddress",
    label: "Email Address",
    component: FormInput,
    className: "cb-form__input--full",
    changeFullHandler: changeHandler
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Field, {
    value: values.streetAddress,
    name: "streetAddress",
    label: "Street Address",
    component: FormInput,
    className: "cb-form__input--full",
    changeFullHandler: changeHandler
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Field, {
    value: values.city,
    name: "city",
    label: "City",
    component: FormInput,
    className: "cb-form__input--full",
    changeFullHandler: changeHandler
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Field, {
    value: state,
    name: "state",
    component: FormSelect,
    options: states,
    changeHandler: changeHandler
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Field, {
    value: values.userZipCode,
    name: "userZipCode",
    label: "Zip Code",
    component: FormInput,
    className: "cb-form__input--full",
    changeFullHandler: changeHandler
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(CheckboxInput, {
    name: "termsAndConditions",
    label: /*#__PURE__*/React.createElement(React.Fragment, null, "I have reviewed and accepted the \xA0 ", /*#__PURE__*/React.createElement("a", {
      href: "#",
      onClick: function onClick(e) {
        e.preventDefault();
        handleUrl("/terms-of-use");
      }
    }, "Terms of Use"), " \xA0 and \xA0 ", /*#__PURE__*/React.createElement("a", {
      href: "#",
      onClick: function onClick(e) {
        e.preventDefault();
        handleUrl("/privacy");
      }
    }, "Privacy Policy"), "."),
    component: CheckboxInput,
    setFieldValue: setFieldValue,
    changeFullHandler: changeHandler
  }))));
});

var CheckboxInput = function CheckboxInput(props) {
  var value = props.value,
      changeFullHandler = props.changeFullHandler;
  return /*#__PURE__*/React.createElement(Field, _extends({}, props, {
    name: props.name,
    render: function render(_ref) {
      var field = _ref.field;
      return /*#__PURE__*/React.createElement(FormCheckbox, {
        value: value,
        field: field,
        type: "checkbox",
        label: props.label,
        checked: field.value,
        onClick: function onClick() {
          return props.setFieldValue(props.name, !field.value);
        },
        changeFullHandler: changeFullHandler
      });
    }
  }));
};